<template>
  <form novalidate @submit.prevent="submit">
    <c-flex gap="lg" :flex-direction="{ base: 'column', md: 'row' }">
      <c-form-control is-required :is-invalid="inputIsInvalid('length')" mb="0">
        <c-flex
          :flex-direction="{ base: 'column', sm: 'row', md: 'column' }"
          align-items="baseline"
          data-cy="length-input-wrapper"
        >
          <c-form-label :for="'length' + index" :d="index > 0 && { md: 'none' }" :mb="{ md: 'md' }">
            {{ $t("common.measurement.length") }} ({{ measurementTypeTranslation }})
          </c-form-label>
          <c-box flex="1" width="100%">
            <c-input
              :id="'length' + index"
              :data-cy="'length' + index"
              v-model="form.length"
              :class="getFieldClasses('length')"
              type="text"
              @change="updateNumber(form.length, 'length')"
              @keyup="onFieldChange('length')"
              @blur="onFieldBlur('length')"
              width="100%"
              :max-width="{ '2xl': '8rem' }"
              size="lg"
            />
          </c-box>
        </c-flex>
      </c-form-control>
      <c-form-control is-required :is-invalid="inputIsInvalid('width')" mb="0">
        <c-flex
          :flex-direction="{ base: 'column', sm: 'row', md: 'column' }"
          align-items="baseline"
          data-cy="width-input-wrapper"
        >
          <c-form-label :for="'width' + index" :d="index > 0 && { md: 'none' }" :mb="{ md: 'md' }">
            {{ $t("common.measurement.width") }} ({{ measurementTypeTranslation }})
          </c-form-label>
          <c-box flex="1" width="100%">
            <c-input
              :id="'width' + index"
              :data-cy="'width' + index"
              v-model="form.width"
              :class="getFieldClasses('width')"
              type="text"
              @change="updateNumber(form.width, 'width')"
              @keyup="onFieldChange('width')"
              @blur="onFieldBlur('width')"
              width="100%"
              :max-width="{ '2xl': '8rem' }"
              size="lg"
            />
          </c-box>
        </c-flex>
      </c-form-control>
      <c-form-control is-required :is-invalid="inputIsInvalid('height')" mb="0">
        <c-flex
          :flex-direction="{ base: 'column', sm: 'row', md: 'column' }"
          align-items="baseline"
          data-cy="height-input-wrapper"
        >
          <c-form-label :for="'height' + index" :d="index > 0 && { md: 'none' }" :mb="{ md: 'md' }">
            {{ $t("common.measurement.height") }} ({{ measurementTypeTranslation }})
          </c-form-label>
          <c-box flex="1" width="100%">
            <c-input
              :id="'height' + index"
              :data-cy="'height' + index"
              v-model="form.height"
              :class="getFieldClasses('height')"
              type="text"
              @change="updateNumber(form.height, 'height')"
              @keyup="onFieldChange('height')"
              @blur="onFieldBlur('height')"
              width="100%"
              :max-width="{ '2xl': '8rem' }"
              size="lg"
            />
          </c-box>
        </c-flex>
      </c-form-control>
    </c-flex>
  </form>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import { FormValidationMixin } from "@/components/FormValidationMixin.js";
import { CBox, CFlex, CFormControl, CFormLabel, CInput, CText } from "@chakra-ui/vue";
import { inputMixin } from "./RMAMixins";

export default defineComponent({
  name: "RMACRMeasurementsPerPackageEditor",
  mixins: [inputMixin, FormValidationMixin],
  components: {
    CBox,
    CFormControl,
    CFormLabel,
    CInput,
    CText,
    CFlex,
  },
  validations: {
    form: {
      length: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(200),
      },
      width: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(200),
      },
      height: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(200),
      },
    },
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    useImperialUnits: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      formErrors: [],
      form: {
        length: "",
        width: "",
        height: "",
      },
    };
  },
  computed: {
    measurementTypeTranslation() {
      return this.$t(`common.measurementType.${this.useImperialUnits ? "in" : "cm"}`);
    },
  },
  methods: {
    updateNumber(n: any, field: string) {
      const newValue = this.limitNumber(n, 1, 200, 1);
      (this.form as any)[field] = newValue;
    },
    limitNumber(t: any, min: number, max: number, d: number): number {
      if (t) {
        const s = `${t}`;
        const v: any = Number(s.replace(/,/g, "."));
        if (!isNaN(v)) {
          if (v < min) {
            return min;
          }
          if (v > max) {
            return max;
          }
          return v;
        }
        return d;
      }
      return t;
    },
    submit() {
      // Do nothing
    },
  },
});
</script>
